/**
 * @file     motion.ts
 * @readme   ./README.md
 * @purpose  Defines animation tokens: duration scale, easing curves, interaction micro-motion values, and step-transition timings.
 */
import type { MotionTokens } from '@/core/types';

export const motionTokens: MotionTokens = {
  durations: {
    instant: 100,
    fast: 160,
    base: 240,
    normal: 240,
    slow: 360
  },
  easing: {
    standard: 'cubic-bezier(0.2, 0, 0, 1)',
    decelerate: 'cubic-bezier(0.05, 0.7, 0.1, 1)',
    accelerate: 'cubic-bezier(0.3, 0, 0.8, 0.15)',
    emphasized: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
    spring: 'cubic-bezier(0.32, 0.72, 0, 1)'
  },
  interaction: {
    hoverLift: -2,
    cardScale: 1.01,
    pressScale: 0.98,
    pressScaleSmall: 0.94,
    photoZoom: 1.03,
    fadeUpDistance: 14
  },
  reveal: {
    distance: 16,
    duration: 360,
    scaleInFrom: 0.96,
    blurInFilterPx: 8
  },
  feedback: {
    helperTextDuration: 160,
    helperTextOffset: 4,
    progressDuration: 240
  },
  loading: {
    skeletonPulseDuration: 1600,
    staggerDelay: 60
  },
  orchestration: {
    initialRevealDelay: 100,
    contentSwapDelay: 1800
  },
  stepTransition: {
    enterDuration: 240,
    exitDuration: 160,
    heightDuration: 280,
    offset: 16,
    overflowBuffer: 8
  }
};
